module.exports = __webpack_public_path__ + "img/google_icon.2f86ab1b.png";